import { useQuery } from '@tanstack/react-query';
import { nitroBrewHttpClient } from 'api/nitro-brew';
import { GENERAL_API_STALE } from 'config/query-config';
export const NITRO_BREW_QUERY_KEYS = {
    all: [
        'nitro-brew'
    ],
    agents: ()=>[
            ...NITRO_BREW_QUERY_KEYS.all,
            'agents'
        ]
};
export const useNitroBrewAgentsQuery = (options)=>{
    var _ref;
    return useQuery({
        queryKey: NITRO_BREW_QUERY_KEYS.agents(),
        queryFn: ()=>nitroBrewHttpClient.getAgents(),
        staleTime: GENERAL_API_STALE,
        enabled: (_ref = options === null || options === void 0 ? void 0 : options.enabled) !== null && _ref !== void 0 ? _ref : true
    });
};
